import { Box, Typography } from '@mui/material'
import WhaleElement from 'containers/dashboard/benchmarkReport/whalesSection/components/WhaleElement'
import { Whale } from 'store/reporting/benchmark/types'

type Props = { whales: Whale[] | null; limit?: number }

export default function WhalesList({ whales, limit }: Props) {
  if (!whales) return <></>
  return (
    <>
      <Typography variant="h6" my={2}>
        First {limit || 10} whales:
      </Typography>
      {whales.slice(0, limit || 10).map((whale, index) => (
        <Box
          key={index}
          mb={2}
          p={2}
          border={1}
          borderColor="grey.300"
          borderRadius={4}
          sx={{
            '& .MuiTypography-root': {
              fontSize: '0.8rem',
            },
          }}>
          {index + 1}. <WhaleElement whale={whale} />
        </Box>
      ))}
    </>
  )
}
